import getDeviceId from '@picsart/rc/getDeviceId';
import HttpService from '@picsart/rc/services/http';
import { EDITOR_QUERY_NAME } from 'types/global';
import { WebEditor } from './types';

export const discordUrlPaths = 'shop/subscription/company-promos/discord/code';
export const API_URL = process.env.REACT_APP_API_URL;
export const CMS_API_URL = process.env.REACT_APP_CMS_API_URL;

export const postUrls = `/get-posts?type=blog-posts`;
export const FONTS_SEARCH_ENDPOINT = `/shop/items/search`;
export const FONTS_DISCOVER_ENDPOINT = `/fonts/discover/trending`;

HttpService.setOptions({
  headers: { platform: 'website', deviceId: getDeviceId() },
});

HttpService.setConfig({
  apiUrl: API_URL,
});

export const webEditor: WebEditor = {
  createExternal: imageUrl => `https://picsart.com/create/editor?image=${imageUrl}`,
  createInternal: (imageId, type = 'imageId') =>
    `/create/editor?${type}=${imageId}${
      type === EDITOR_QUERY_NAME.template ? '&category=templates' : ''
    }`,
  createAILink: ({ caption, styles = '' }) =>
    `/create/editor?category=templates&app=t2i&prompt=${encodeURIComponent(caption)}${
      styles ? `&styles=${encodeURIComponent(styles)}` : ''
    }`,
};
